import React, { useState } from 'react';
import { useData } from '../../store/DataContext';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { PlusIcon, TruckIcon } from 'lucide-react';
export function Suppliers() {
  const {
    suppliers,
    addSupplier,
    updateSupplier
  } = useData();
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    name: '',
    contactPerson: '',
    phone: '',
    email: '',
    address: ''
  });
  const [error, setError] = useState('');
  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      setError('Supplier name and phone number are required.');
      return;
    }
    addSupplier({
      ...form,
      name: form.name.trim(),
      contactPerson: form.contactPerson.trim(),
      phone: form.phone.trim(),
      status: 'Active'
    });
    setForm({
      name: '',
      contactPerson: '',
      phone: '',
      email: '',
      address: ''
    });
    setError('');
    setShowForm(false);
  };
  const toggleSupplierStatus = (supplierId: string, status: 'Active' | 'Inactive') => {
    updateSupplier(supplierId, {
      status: status === 'Active' ? 'Inactive' : 'Active'
    });
  };
  return <div className="space-y-5" data-id="element-4625">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-4626">
        <div data-id="element-4627">
          <h2 className="text-xl font-bold text-slate-950" data-id="element-4628">Suppliers</h2>
          <p className="mt-1 text-sm text-slate-500" data-id="element-4629">
            Maintain the suppliers used for stock receiving and purchase orders.
          </p>
        </div>
        <Button onClick={() => setShowForm(true)} className="bg-teal-600 hover:bg-teal-700" data-id="element-4630">
          <PlusIcon className="mr-2 h-4 w-4" data-id="element-4631" /> Add supplier
        </Button>
      </div>
      {showForm && <form onSubmit={submit} className="grid grid-cols-1 gap-4 rounded-xl border border-teal-200 bg-teal-50/50 p-5 md:grid-cols-2" data-id="element-4632">
          <div className="md:col-span-2 flex justify-between" data-id="element-4633">
            <h3 className="font-bold text-slate-900" data-id="element-4634">New supplier</h3>
            <button type="button" onClick={() => setShowForm(false)} className="text-sm font-semibold text-slate-500 hover:text-slate-900" data-id="element-4635">
              Cancel
            </button>
          </div>
          {error && <p className="md:col-span-2 text-sm text-red-600" data-id="element-4636">{error}</p>}
          <Input label="Supplier name" required value={form.name} onChange={e => setForm({
        ...form,
        name: e.target.value
      })} data-id="element-4637" />
          <Input label="Contact person" value={form.contactPerson} onChange={e => setForm({
        ...form,
        contactPerson: e.target.value
      })} data-id="element-4638" />
          <Input label="Phone" required value={form.phone} onChange={e => setForm({
        ...form,
        phone: e.target.value
      })} data-id="element-4639" />
          <Input label="Email" type="email" value={form.email} onChange={e => setForm({
        ...form,
        email: e.target.value
      })} data-id="element-4640" />
          <Input label="Address" className="md:col-span-2" value={form.address} onChange={e => setForm({
        ...form,
        address: e.target.value
      })} data-id="element-4641" />
          <div className="md:col-span-2 flex justify-end" data-id="element-4642">
            <Button type="submit" className="bg-teal-600 hover:bg-teal-700" data-id="element-4643">
              Save supplier
            </Button>
          </div>
        </form>}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2" data-id="element-4644">
        {suppliers.map(supplier => <article key={supplier.id} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-id="element-4645">
            <div className="flex items-start gap-3" data-id="element-4646">
              <div className="rounded-lg bg-teal-50 p-2.5 text-teal-700" data-id="element-4647">
                <TruckIcon className="h-5 w-5" data-id="element-4648" />
              </div>
              <div className="min-w-0 flex-1" data-id="element-4649">
                <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-4650">
                  <h3 className="font-bold text-slate-900" data-id="element-4651">{supplier.name}</h3>
                  <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${supplier.status === 'Active' ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-600'}`} data-id="element-4652">
                    {supplier.status}
                  </span>
                </div>
                <p className="mt-1 text-sm text-slate-600" data-id="element-4653">
                  {supplier.contactPerson || 'No contact person'} ·{' '}
                  {supplier.phone}
                </p>
                {supplier.email && <p className="mt-1 text-sm text-slate-500" data-id="element-4654">
                    {supplier.email}
                  </p>}
                {supplier.address && <p className="mt-1 text-sm text-slate-500" data-id="element-4655">
                    {supplier.address}
                  </p>}
                <Button type="button" size="sm" variant="outline" onClick={() => toggleSupplierStatus(supplier.id, supplier.status)} className="mt-4" data-id="element-4656">
                  {supplier.status === 'Active' ? 'Deactivate' : 'Activate'}
                </Button>
              </div>
            </div>
          </article>)}
        {!suppliers.length && <div className="col-span-full rounded-xl border border-dashed border-slate-300 py-14 text-center text-sm text-slate-500" data-id="element-4657">
            No suppliers yet. Add a supplier before creating purchase orders.
          </div>}
      </div>
    </div>;
}